import { VisitDto } from '@ecdlink/core';
import { format } from 'date-fns';

export interface StatusInfo {
  color: string;
  icon: string;
  notes: string;
  subject: string;
}

export function getInfantStatusInfo(visits?: VisitDto[]): StatusInfo {
  const status: StatusInfo = {
    color: '',
    icon: '',
    notes: 'child',
    subject: '',
  };

  if (visits) {
    const today = new Date();
    const sevenDaysFromNow = addDays(today, 7);
    const nextVisitWithin7Days = visits.filter((x) => {
      const visitDate = new Date(x.plannedVisitDate);
      return !x.attended && visitDate >= today && visitDate <= sevenDaysFromNow;
    });

    if (nextVisitWithin7Days.length > 0) {
      const firstInList = nextVisitWithin7Days[0];
      status.color = 'Warning';
      status.icon = 'Warning';
      status.notes = 'child';
      status.subject =
        firstInList?.visitType?.normalizedName +
        ' due ' +
        format(new Date(firstInList?.dueDate), 'dd MMM yyyy');
      return status;
    }

    const nextVisit = visits.filter((x) => {
      const visitDate = new Date(x.plannedVisitDate);
      return !x.attended && visitDate >= today;
    });
    if (nextVisit.length > 0) {
      const firstInList = nextVisit[0];
      status.subject =
        firstInList?.visitType?.normalizedName +
        ' due ' +
        format(new Date(firstInList?.dueDate), 'dd MMM yyyy');
      return status;
    }
  }

  return status;
}

function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
